import axios from 'axios';
import { encryptPayload,decryptResponse } from './crypto_utils';


export const apiCommonTriggerApi = async (method , url , data =null ) => {
    let Authorize = localStorage.getItem("accessKey");
    if (Authorize) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + Authorize;
    }else {
        axios.defaults.headers.common['Authorization'] = '';
    }
    let response;

    try {    
        if (method.toUpperCase() === 'POST') {
            const encryptedPayload = await encryptPayload(data);
            response = await axios({
                url: url,
                method: method.toUpperCase(),
                data : { data: encryptedPayload }
            })
        } else {
            response = await axios({
                url: url,
                method: method.toUpperCase()
            })
        }     

        response.data = await decryptResponse(response.data);
        return response;
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
};
 

export const apiCommonTrigger = async (
    method,
    url,
    data = null,
    config = {},
    skipAuth = false
  ) => {
    try {
      const upperMethod = method.toUpperCase();
      const headers = { ...axios.defaults.headers.common };
      const token = localStorage.getItem("accessKey");
      const demo_token = localStorage.getItem('demo-token') !== null ? localStorage.getItem('demo-token') : null;
      config = typeof config === 'object' && config !== null ? config : {};
  
      if (!skipAuth && token) {
        headers["Authorization"] = token ? `Bearer ${token}` : "";
      }
      if(demo_token){
        headers["x-access-token"] = demo_token;
      }
  
      // Always assign headers explicitly to avoid mutation of global defaults
      config.headers = { ...headers, ...(config.headers || {}) };
  
      let response;
  
      if (upperMethod === "POST") {
        const encryptedPayload = await encryptPayload(data);
        response = await axios.post(url, { data: encryptedPayload }, config);
  
      } else if (upperMethod === "GET"){
        //In case id is passing in array 
        if( Array.isArray(data) && data.length > 0){
          const querySegments = await Promise.all(
          data.map(async item => encodeURIComponent(await encryptPayload(item, "get")))
        );
        const finalURL = `${url}${querySegments.join("/")}`.replace(/\/$/, "");  
        response = await axios.get(finalURL, config);
        }
        //In case id is encrypted directly in url 
        else{
          response = await axios.get(url, config);
        }
      } 
      
       else if (upperMethod === "DELETE"){
        //In case id is passing in array 
        if(Array.isArray(data) && data.length > 0){
          const encryptedSegments = await Promise.all(
          data.map(async item => encodeURIComponent(await encryptPayload(item, "delete")))
          );
        const finalURL = `${url}${encryptedSegments.join("/")}`.replace(/\/$/, "");
        response = await axios.delete(finalURL, config);
        }
        //In case id is encrypted directly in url 
        else{
         response = await axios.delete(url, config);
        }
       }
       else {
        throw new Error("Unsupported  method");
      }
      if(config?.responseType === 'blob') return response;  
      response.data = await decryptResponse(response.data);
      return response;
  
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  };
  

export const apiCommonTriggerBlob = async (method , url , data =null ) => {

    let Authorize = localStorage.getItem("accessKey");
    if (Authorize) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + Authorize;
    }else {
        axios.defaults.headers.common['Authorization'] = '';
    }
    let response;

    try {    
        if (method.toUpperCase() === 'POST') {
            const encryptedPayload = await encryptPayload(data);
            response = await axios({
                url: url,
                method: method.toUpperCase() ,
                responseType: 'blob',
                data : {data : encryptedPayload},
                headers: {
                    'Content-Type': 'application/json',
                },
            })
        } else {
            let finalURL = url;
            if(data && data.length){
                const querySegments = await Promise.all(
                    data.map(async item => encodeURIComponent(await encryptPayload(item, "get")))
                  );        
                finalURL = `${url}${querySegments.join("/")}`.replace(/\/$/, "");  
            }

            response = await axios({
                url: finalURL,
                method: method.toUpperCase() ,
                responseType: 'blob'
            })
        }     
        return response;
    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
};